import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'comments',
    label: 'Comments',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
